/** Converte firma ECDSA P1363 (Web Crypto) → DER (Java/Node compat). */
export function ecdsaP1363ToDer(signature: ArrayBuffer, orderByteLength = 32): ArrayBuffer {
  const raw = new Uint8Array(signature)
  if (raw.length !== orderByteLength * 2) {
    return signature
  }
  const r = trimInteger(raw.slice(0, orderByteLength))
  const s = trimInteger(raw.slice(orderByteLength))
  const body = concatBytes(encodeDerInteger(r), encodeDerInteger(s))
  const seq = concatBytes([0x30], encodeDerLength(body.length), body)
  const out = new Uint8Array(seq.length)
  out.set(seq)
  return out.buffer
}

function trimInteger(bytes: Uint8Array): Uint8Array {
  let start = 0
  while (start < bytes.length - 1 && bytes[start] === 0) start++
  let slice = bytes.slice(start)
  if (slice[0]! & 0x80) {
    const padded = new Uint8Array(slice.length + 1)
    padded[0] = 0
    padded.set(slice, 1)
    slice = padded
  }
  return slice
}

function encodeDerInteger(bytes: Uint8Array): Uint8Array {
  return concatBytes([0x02], encodeDerLength(bytes.length), bytes)
}

function encodeDerLength(len: number): Uint8Array {
  if (len < 0x80) return new Uint8Array([len])
  const bytes: number[] = []
  let n = len
  while (n > 0) {
    bytes.unshift(n & 0xff)
    n >>= 8
  }
  return new Uint8Array([0x80 | bytes.length, ...bytes])
}

function concatBytes(...parts: Array<Uint8Array | number[]>): Uint8Array {
  const total = parts.reduce((sum, p) => sum + p.length, 0)
  const out = new Uint8Array(total)
  let offset = 0
  for (const part of parts) {
    out.set(part, offset)
    offset += part.length
  }
  return out
}
